// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3FQHD","validationTips":"StatementDescriptor_validationTips__3mdA2"};